var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "onboarding step-container",
      attrs: { id: "onboardingStaff" }
    },
    [
      _c("preloader", { attrs: { display: _vm.loading } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "aright" },
        [_c("lang-selector", { attrs: { value: _vm.locale } })],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "onboardingForm",
          staticClass: "step-slide-container",
          attrs: {
            "label-position": "top",
            model: _vm.staff,
            "inline-message": true,
            "label-width": "120px"
          }
        },
        [
          _c("div", { staticClass: "step active", attrs: { "step-id": "1" } }, [
            _c(
              "div",
              { staticClass: "step-division division-2 br-1-color26" },
              [
                _c("img", {
                  attrs: {
                    src:
                      "/ressources/public/img/onboarding/Sellsy_produit_onboarding1.png"
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "step-division division-2" },
              [
                _c("h2", { staticClass: "mb-0 lh-reset" }, [
                  _vm._v(_vm._s(_vm.$l10n.__("Créez votre profil")))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "mt-0 mb-7 semibold gray-60" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$l10n.__("Afin de pouvoir rejoindre votre équipe")
                      ) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t.__("common.labels.first_name"),
                      prop: "forename",
                      error: _vm.errors.get("forename")
                    }
                  },
                  [
                    _c("text-input", {
                      attrs: {
                        mode: "edit",
                        placeholder: _vm.$t.__("common.labels.first_name")
                      },
                      model: {
                        value: _vm.staff.forename,
                        callback: function($$v) {
                          _vm.$set(_vm.staff, "forename", $$v)
                        },
                        expression: "staff.forename"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t.__("common.labels.name"),
                      prop: "name",
                      error: _vm.errors.get("name")
                    }
                  },
                  [
                    _c("text-input", {
                      attrs: {
                        mode: "edit",
                        placeholder: _vm.$t.__("common.labels.name")
                      },
                      model: {
                        value: _vm.staff.name,
                        callback: function($$v) {
                          _vm.$set(_vm.staff, "name", $$v)
                        },
                        expression: "staff.name"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "acenter" },
                  [
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__("common.actions.continue"),
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.validateStep($event)
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }